"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useEventListener = _interopRequireDefault(require("../useEventListener"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useScrollPosition = function useScrollPosition() {
  var _a = (0, _react.useState)({
      scrollX: 0,
      scrollY: 0
    }),
    position = _a[0],
    setPosition = _a[1];
  var prevPosition = (0, _react.useRef)(position);
  var onEvent = (0, _react.useCallback)(function () {
    var scrollX = window.scrollX,
      scrollY = window.scrollY;
    var _a = prevPosition.current,
      prevX = _a.scrollX,
      prevY = _a.scrollY;
    if (prevX !== scrollX || prevY !== scrollY) {
      var newPosition = {
        scrollX: scrollX,
        scrollY: scrollY
      };
      prevPosition.current = newPosition;
      setPosition(newPosition);
    }
  }, []);
  (0, _useEventListener.default)('scroll', onEvent);
  return position;
};
var _default = useScrollPosition;
exports.default = _default;